import React from 'react';
import { debounce } from "../../wui-core/src/browserUtils";

export interface ResizeProps {
  throttle?: boolean;
  onResize?: (entry: ResizeObserverEntry[]) => void;
  children?: React.ReactElement;
}

class ResizeObserverComponent extends React.Component<ResizeProps> {
  resizeObserver: any;

  divRef: any = null;

  componentDidMount() {
      if (!React.isValidElement(this.props.children)) {
          console.warn('The children of ResizeObserver is invalid.');
      } else {
          this.createResizeObserver();
      }
  }

  componentDidUpdate() {
      if (!this.resizeObserver && this.divRef) {
          this.createResizeObserver();
      }
  }

  componentWillUnmount = () => {
      if (this.resizeObserver) {
          this.destroyResizeObserver();
      }
  };

  createResizeObserver = () => {
      const { throttle = true } = this.props;
      const onResize = (entry: ResizeObserverEntry[]) => {
          this.props.onResize?.(entry);
      };

      const resizeHandler = throttle ? debounce(onResize, 50, false) : onResize;

      let firstExec = true; // 首次监听时，立即执行一次 onResize，之前行为保持一致，避免布局类组件出现闪动的情况
      this.resizeObserver = new ResizeObserver((entry) => {
          if (firstExec) {
              firstExec = false;
              onResize(entry);
          }
          resizeHandler(entry);
      });
      this.resizeObserver.observe(this.divRef as Element);
  };

  destroyResizeObserver = () => {
      this.resizeObserver && this.resizeObserver.disconnect();
      this.resizeObserver = null;
  };

  render() {
      return React.cloneElement(this.props.children as React.ReactElement, {ref: (ref: any) => this.divRef = ref});
  }
}

export default ResizeObserverComponent;
